import Parallax from 'parallax-js';

import vars from '../helpers';

const getElements = () => [...document.querySelectorAll('[data-parallax]')];

const destroy = () => {
	getElements().forEach((element) => {
		if (element.parallax) {
			element.parallax.destroy();

			element.parallax = undefined;
		}
	});
};

const init = () => {
	if (vars.isMobile()) {
		return;
	}

	getElements().forEach((element) => {
		element.parallax = new Parallax(element, {
			scalarX: 2,
			scalarY: 2,
		});
	});
};

const resize = () => {
	destroy();
	init();
};

export default {
	init,
	destroy,
	resize,
};
